import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, LogOut } from 'lucide-react';

/**
 * AUTOPISTA_MARKER — Cabecera ÚNICA de las secciones de cliente.
 * Barra teal fina, a todo el ancho (full-bleed), igual que "Clases Online".
 * La usan TODAS las pestañas del canal (Cambios, Mi Perfil, Clínica, Clases online)
 * para que la cabecera sea idéntica en todas partes (decisión de Ann).
 *
 * Props:
 *  - title, subtitle, onBack, onLogout, backLabel (por defecto "Volver").
 *  - logoSrc / logoAlt: logo OPCIONAL a la IZQUIERDA, donde iría el rótulo. Lo pidió
 *    Ann para Clínica (el logo de MEFIR en vez del rótulo "Mi Clínica"). Es opcional
 *    a propósito: las demás secciones no lo pasan y se ven EXACTAMENTE igual que
 *    antes, así la cabecera sigue siendo la misma en todas partes.
 *  - wrapClass: clases responsive para LIMITAR el ancho en PC/tablet al bloque de
 *    contenido (p. ej. "md:max-w-2xl md:mx-auto md:px-4"). En móvil (sin md:) la barra
 *    va a todo el ancho. Vacío = full-bleed siempre (como "Clases Online").
 */
const ClientSectionHeader = ({ title, subtitle, onBack, onLogout, backLabel, wrapClass = '', logoSrc = '', logoAlt = '' }) => {
  // i18n del chrome de cliente (encargo interior CA): Volver/Salir según idioma.
  const { t } = useTranslation('common');
  const back = backLabel || t('comunes.volver');
  return (
  <div className={`w-full ${wrapClass}`}>
    <div className="text-white shadow-md md:rounded-b-2xl"
         style={{ background: 'linear-gradient(120deg,#3C8696,#2C6675)' }}>
      <div className="flex items-center justify-between gap-3 px-4 py-2.5">
        <div className="min-w-0 flex items-center gap-3">
          {logoSrc && (
            <img src={logoSrc} alt={logoAlt || ''} className="h-7 w-auto object-contain flex-shrink-0"
                 onError={(e) => { e.currentTarget.style.display = 'none'; }} />
          )}
          {title && <h1 className="text-base font-extrabold leading-tight truncate">{title}</h1>}
          {subtitle && <p className="text-[11px] opacity-90 leading-tight truncate">{subtitle}</p>}
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          {onBack && (
            <button onClick={onBack}
              className="inline-flex items-center gap-1.5 h-8 px-3 rounded-lg text-[13px] font-semibold text-white bg-white/15 border border-white/30 hover:bg-white/25">
              <ArrowLeft className="w-4 h-4" /> {back}
            </button>
          )}
          {onLogout && (
            <button onClick={onLogout}
              className="inline-flex items-center gap-1.5 h-8 px-3 rounded-lg text-[13px] font-semibold text-white bg-white/15 border border-white/30 hover:bg-white/25">
              <LogOut className="w-4 h-4" /> {t('comunes.salir')}
            </button>
          )}
        </div>
      </div>
    </div>
  </div>
);
};

export default ClientSectionHeader;